var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#FFFFFF;}\r\n\t.st2{fill:#8DC03E;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:2.1628;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-width:3.2675;stroke-miterlimit:10;}\r\n\t.st5{font-family:'OpenSans-Extrabold';}\r\n\t.st6{font-size:37.1855px;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:2.4187;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st8{fill:none;}\r\n\t.st9{font-family:'MyriadPro-Regular';}\r\n\t.st10{font-size:18px;}\r\n\t.st11{fill:none;stroke:#000000;stroke-width:2.2614;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st12{fill:none;stroke:#000000;stroke-width:2.1628;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3.2675,7.6242;}\r\n\t\r\n\t\t.st13{fill:none;stroke:#000000;stroke-width:2.0166;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3.0467,7.1089;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 500,
    height: 500
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS_copia"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M195.8,287.6h-13.1v23H151v-23h-47.5V264l49.5-72.4h29.7v72h13.1V287.6z M151,263.6v-13.8 c0-2.6,0.1-6.1,0.3-10.5c0.2-4.4,0.3-6.7,0.4-7h-0.9c-1.8,4.2-3.9,8.1-6.3,11.7l-13.2,19.6H151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.2,251.3c0,21.1-3.5,36.5-10.6,46.3c-7.1,9.8-17.9,14.7-32.4,14.7c-14.2,0-24.9-5.1-32.2-15.4 c-7.2-10.2-10.8-25.5-10.8-45.6c0-21.2,3.5-36.7,10.6-46.6c7.1-9.9,17.9-14.8,32.4-14.8c14.2,0,24.9,5.1,32.1,15.4 C286.6,215.6,290.2,231,290.2,251.3z M236.2,251.3c0,13.5,0.8,22.7,2.5,27.8c1.7,5,4.5,7.6,8.5,7.6c4,0,6.9-2.6,8.5-7.8 c1.7-5.2,2.5-14.4,2.5-27.5c0-13.2-0.8-22.4-2.5-27.7c-1.7-5.3-4.5-7.9-8.5-7.9c-4,0-6.8,2.6-8.5,7.7 C237.1,228.4,236.2,237.7,236.2,251.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M391.3,287.6h-13.1v23h-31.8v-23h-47.5V264l49.5-72.4h29.7v72h13.1V287.6z M346.4,263.6v-13.8 c0-2.6,0.1-6.1,0.3-10.5c0.2-4.4,0.3-6.7,0.4-7h-0.9c-1.8,4.2-3.9,8.1-6.3,11.7l-13.2,19.6H346.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 55.8,
    y1: 218,
    x2: 103.9,
    y2: 218
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 115.4,
    y1: 218,
    x2: 125.7,
    y2: 218
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 47,
    y1: 204.5,
    x2: 133.2,
    y2: 204.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 39.9,
    y1: 204.5,
    x2: 32.8,
    y2: 204.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 47,
    y1: 191.6,
    x2: 75.6,
    y2: 191.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 83.3,
    y1: 191.6,
    x2: 143.4,
    y2: 191.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 396,
    y1: 325.5,
    x2: 447.5,
    y2: 325.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 455.9,
    y1: 325.5,
    x2: 463.3,
    y2: 325.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 406.3,
    y1: 312,
    x2: 473.8,
    y2: 312
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 401.2,
    y1: 312,
    x2: 396,
    y2: 312
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 396,
    y1: 299.1,
    x2: 427,
    y2: 299.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 432.6,
    y1: 299.1,
    x2: 455.9,
    y2: 299.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M202,287.2h-13.1v23h-31.8v-23h-47.5v-23.6l49.5-72.4h29.7v72H202V287.2z M157.1,263.2v-13.8 c0-2.6,0.1-6.1,0.3-10.5c0.2-4.4,0.3-6.7,0.4-7H157c-1.8,4.2-3.9,8.1-6.3,11.7l-13.2,19.6H157.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M296.4,250.9c0,21.1-3.5,36.5-10.6,46.3c-7.1,9.8-17.9,14.7-32.4,14.7c-14.2,0-24.9-5.1-32.2-15.4 c-7.2-10.2-10.8-25.5-10.8-45.6c0-21.2,3.5-36.7,10.6-46.6c7.1-9.9,17.9-14.8,32.4-14.8c14.2,0,24.9,5.1,32.1,15.4 C292.8,215.2,296.4,230.5,296.4,250.9z M242.4,250.9c0,13.5,0.8,22.7,2.5,27.8c1.7,5,4.5,7.6,8.5,7.6c4,0,6.9-2.6,8.5-7.8 c1.7-5.2,2.5-14.4,2.5-27.5c0-13.2-0.8-22.4-2.5-27.7c-1.7-5.3-4.5-7.9-8.5-7.9c-4,0-6.8,2.6-8.5,7.7 C243.2,227.9,242.4,237.3,242.4,250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M397.5,287.2h-13.1v23h-31.8v-23h-47.5v-23.6l49.5-72.4h29.7v72h13.1V287.2z M352.6,263.2v-13.8 c0-2.6,0.1-6.1,0.3-10.5c0.2-4.4,0.3-6.7,0.4-7h-0.9c-1.8,4.2-3.9,8.1-6.3,11.7L333,263.2H352.6z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 190.3823 362.4004)",
    className: "st5 st6"
  }, "ERROR"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 418.5,
    y1: 215.1,
    x2: 418.5,
    y2: 204.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 410.8,
    y1: 218.3,
    x2: 403,
    y2: 210.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 407.6,
    y1: 226,
    x2: 396.6,
    y2: 226
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 410.8,
    y1: 233.7,
    x2: 403,
    y2: 241.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 418.5,
    y1: 236.9,
    x2: 418.5,
    y2: 247.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 426.2,
    y1: 233.7,
    x2: 434,
    y2: 241.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 429.4,
    y1: 226,
    x2: 440.4,
    y2: 226
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 426.2,
    y1: 218.3,
    x2: 434,
    y2: 210.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 72.3,
    y1: 270.1,
    x2: 72.3,
    y2: 262.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 66.7,
    y1: 272.4,
    x2: 61,
    y2: 266.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 64.4,
    y1: 277.9,
    x2: 56.4,
    y2: 277.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 66.7,
    y1: 283.5,
    x2: 61,
    y2: 289.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 72.3,
    y1: 285.8,
    x2: 72.3,
    y2: 293.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 77.8,
    y1: 283.5,
    x2: 83.5,
    y2: 289.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 80.1,
    y1: 277.9,
    x2: 88.1,
    y2: 277.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 77.8,
    y1: 272.4,
    x2: 83.5,
    y2: 266.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 288.2,
    y1: 105.3,
    x2: 288.2,
    y2: 97.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 282.6,
    y1: 107.6,
    x2: 277,
    y2: 101.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 280.3,
    y1: 113.1,
    x2: 272.3,
    y2: 113.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 282.6,
    y1: 118.7,
    x2: 277,
    y2: 124.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 288.2,
    y1: 121,
    x2: 288.2,
    y2: 129
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 293.8,
    y1: 118.7,
    x2: 299.4,
    y2: 124.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 296.1,
    y1: 113.1,
    x2: 304,
    y2: 113.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 293.8,
    y1: 107.6,
    x2: 299.4,
    y2: 101.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 326.9,
    className: "st7",
    width: 273.8,
    height: 43.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.6,
    y: 397.1,
    className: "st8",
    width: 275.1,
    height: 30.5
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 115.5073 409.8449)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st9 st10"
  }, "\xA1Oops! Parece que la p\xE1gina a la que "), /*#__PURE__*/React.createElement("tspan", {
    x: 30.6,
    y: 17.4,
    className: "st9 st10"
  }, "intentas dirigirte no existe :(")), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "133.2,172.2 133.2,137.7 312.7,137.7 312.7,214.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "249.4,113.1 249.4,156.4 368.5,156.4 368.5,176  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.5,176.5c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3 C135.6,172.2,137.5,174.1,137.5,176.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 249.4,
    cy: 108.8,
    r: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M372.7,180.8c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3 C370.8,176.5,372.7,178.4,372.7,180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317,219.4c0,2.4-1.9,4.3-4.3,4.3s-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3S317,217,317,219.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 105.3,
    y1: 305.2,
    x2: 95.2,
    y2: 315.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 95.2,
    y1: 305.2,
    x2: 105.3,
    y2: 315.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 110.4,
    y1: 158,
    x2: 100.2,
    y2: 168.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 100.2,
    y1: 158,
    x2: 110.4,
    y2: 168.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 439.1,
    y1: 272.9,
    x2: 428.9,
    y2: 283
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 428.9,
    y1: 272.9,
    x2: 439.1,
    y2: 283
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M151.5,100.2c-3.2,0-6.2,1.2-8.5,3.1c-2.3-7.1-9-12.2-16.8-12.2c-8.8,0-16.1,6.4-17.5,14.8 c-0.9-0.3-1.9-0.4-2.9-0.4c-5.8,0-10.6,4.7-10.6,10.6c0,5.4,4,9.8,9.2,10.5v0.1h47.1c7.3,0,13.2-5.9,13.2-13.2 C164.7,106.1,158.8,100.2,151.5,100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M396.6,167.4c2.3,0,4.5,0.8,6.2,2.2c1.7-5.1,6.5-8.8,12.2-8.8c6.4,0,11.7,4.6,12.7,10.7 c0.7-0.2,1.4-0.3,2.1-0.3c4.2,0,7.7,3.4,7.7,7.7c0,3.9-2.9,7.1-6.7,7.6v0.1h-34.2c-5.3,0-9.6-4.3-9.6-9.6S391.3,167.4,396.6,167.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M443.8,349.1c-2,0-3.8,0.7-5.2,1.9c-1.4-4.3-5.5-7.4-10.3-7.4c-5.4,0-9.8,3.9-10.7,9c-0.6-0.2-1.2-0.3-1.8-0.3 c-3.6,0-6.4,2.9-6.4,6.4c0,3.3,2.4,6,5.6,6.4v0.1h28.7c4.4,0,8.1-3.6,8.1-8.1C451.8,352.7,448.2,349.1,443.8,349.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.3,332.1c2.3,0,4.5,0.8,6.2,2.2c1.7-5.1,6.5-8.8,12.2-8.8c6.4,0,11.7,4.6,12.7,10.7 c0.7-0.2,1.4-0.3,2.1-0.3c4.2,0,7.7,3.4,7.7,7.7c0,3.9-2.9,7.1-6.7,7.6v0.1H54.3c-5.3,0-9.6-4.3-9.6-9.6 C44.6,336.4,48.9,332.1,54.3,332.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M164.7,93.8c0,0,60.4-49.3,142.6-26.6c86.3,23.8,103.5,85.4,103.5,85.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M73.4,237c-23.4,3.6-35.2,53.4-8.9,73.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M368.5,380.5c0,0,40.1,17.5,57.7-6.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 177.5,
    y1: 180.8,
    x2: 177.5,
    y2: 155.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 171.4,
    y1: 180.8,
    x2: 171.4,
    y2: 168.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 270.7,
    y1: 186.6,
    x2: 270.7,
    y2: 168.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 263.7,
    y1: 185,
    x2: 263.7,
    y2: 177.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 257.6,
    y1: 185,
    x2: 257.6,
    y2: 172.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 183.4,
    y1: 180.8,
    x2: 183.4,
    y2: 168.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 351.4,
    y1: 184.3,
    x2: 351.4,
    y2: 178.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 345.3,
    y1: 184.3,
    x2: 345.3,
    y2: 170.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 357.3,
    y1: 184.3,
    x2: 357.3,
    y2: 174.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.dafcf096102a21816ce50a19585e9c32.svg";
export { ForwardRef as ReactComponent };